export const formatCountryToDistrict = (countries, id) => {
  const data = countries
    ?.filter(country => country?.id?.toString() === id?.toString())?.[0]
    ?.province?.map(one_province => one_province?.districts)
  const list = [].concat.apply([], data)
  return list
}
